import React from 'react';
import { Handshake } from 'lucide-react';
export function HeroSection() {
  return <section className="relative py-24 md:py-32 flex items-center border-b border-brand-gray-800 overflow-hidden" data-id="element-819">
      <img src="https://cdn.magicpatterns.com/uploads/nzVURNd69aoekeuJ7eFhBp/Resources_bg.jpg" alt="Strategic Partners" className="block absolute inset-0 w-full h-full object-cover object-center" data-id="element-820" />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-black/50 via-brand-black/40 to-brand-black z-[1]" data-id="element-821" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full text-center" data-id="element-822">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-brand-teal/30 bg-brand-teal/10 text-brand-teal text-xs font-bold uppercase tracking-widest mb-6" data-id="element-823">
          <Handshake className="w-4 h-4" data-id="element-824" />
          Strategic Partners
        </div>
        <h1 className="text-4xl md:text-6xl font-extrabold text-brand-white tracking-tight leading-tight mb-6 uppercase" data-id="element-825">
          Our Resources Page
        </h1>
      </div>
    </section>;
}